import { jsxs, jsx } from "../../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.es.js";
import "../../../node_modules/@bonusx-global/bx-icons/dist/node_modules/react/jsx-runtime.es.es.js";
import "../../../node_modules/@bonusx-global/bx-icons/dist/node_modules/@emotion/react/dist/emotion-element-c39617d8.browser.esm.es.es.js";
import { memo } from "react";
import "../../../node_modules/@bonusx-global/bx-icons/dist/node_modules/hoist-non-react-statics/dist/hoist-non-react-statics.cjs.es.es.js";
import "../../../node_modules/@bonusx-global/bx-icons/dist/node_modules/@emotion/serialize/dist/emotion-serialize.browser.esm.es.es.js";
import "@mui/material";
import { TimesSolid as n } from "../../../node_modules/@bonusx-global/bx-icons/dist/src/icons/solid/times-solid.es.es.js";
import "../../../node_modules/@bonusx-global/bx-icons/dist/src/icons/solid/turn-icons.es.es.js";
import { SnackBarIcon } from "./components/snackbar-icon.es.js";
import Box from "../../../node_modules/@mui/material/Box/Box.es.js";
import { SnackBarContainer } from "./components/snackbar-container.es.js";
import { Spacing } from "../../foundations/spacing.es.js";
import { IconButton } from "../icon-button/icon-button.es.js";
const MemoizedSnackBarIcon = memo(SnackBarIcon, function checkVariantChange(prevProps, nextProps) {
  return prevProps.variant === nextProps.variant;
});
function SnackBar({
  variant,
  message,
  minWidth,
  onCloseButtonClick,
  ...rest
}) {
  return /* @__PURE__ */ jsxs(SnackBarContainer, { variant, ...rest, children: [
    /* @__PURE__ */ jsx(MemoizedSnackBarIcon, { variant }),
    /* @__PURE__ */ jsx(Box, { minWidth: minWidth ?? Spacing["18750"], children: message }),
    /* @__PURE__ */ jsx(IconButton, { color: "inherit", "data-testid": "snackbar-icon-button", size: "medium", onClick: onCloseButtonClick, children: /* @__PURE__ */ jsx(n, {}) })
  ] });
}
export {
  SnackBar
};
//# sourceMappingURL=snackbar.es.js.map
